<template>
  <div style="margin-top: 15px;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }"
          >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/marketing_operations/match_operations_home' }">销售中心</el-breadcrumb-item>
      <el-breadcrumb-item>合同列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <!-- 筛选区 -->
      <el-form :model="queryForm" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户名称">
              <el-input v-model="queryForm.customerName" placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同编号">
              <el-input v-model="queryForm.contractNo" placeholder="请输入合同编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同状态">
              <el-select v-model="queryForm.contractStatus" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in contractStatusList"
                  :key="item.enumkey"
                  :label="item.desc"
                  :value="item.enumkey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审批状态">
              <el-select v-model="queryForm.flowStatus" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in flowStatusList"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付方式">
              <el-select v-model="queryForm.paymentMethod" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in paymentMethodList"
                  :key="item.enumkey"
                  :label="item.desc"
                  :value="item.enumkey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="缴费类型">
              <el-select v-model="queryForm.paymentType" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in paymentTypeList"
                  :key="item.enumkey"
                  :label="item.desc"
                  :value="item.enumkey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目类型">
              <el-select v-model="queryForm.projectType" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in projectTypeList"
                  :key="item.enumkey"
                  :label="item.desc"
                  :value="item.enumkey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收费日期">
              <el-date-picker
                v-model="paymentDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
                @change="handleDateRangeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" align="right">
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">合同列表</span>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" plain @click="exportFn">导出数据</el-button>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-table :data="tableData" v-loading="tableLoading"
        header-cell-class-name="tableHeaderStyle"
        ref="purchasePackage"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="customerName" label="客户名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractNo" label="合同编号"></el-table-column>
        <el-table-column prop="partyA" label="甲方" show-overflow-tooltip></el-table-column>
        <el-table-column prop="partyB" label="乙方" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractAmount" label="合同金额" align="right"></el-table-column>
        <el-table-column prop="contractStatusEnum" label="合同状态" align="center">
          <template slot-scope="scope">
            <el-tag size="small" effect="plain" :type="getStatusType(scope.row.contractStatusEnum)">
              {{ scope.row.contractStatusDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="contractStatusEnum" label="审批状态" min-width="100px" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="getFlowStatusType(scope.row.flowStatus)">
              {{ getFlowStatusStr(scope.row.flowStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paymentMethodDesc" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="paymentTypeDesc" label="缴费类型" align="center"></el-table-column>
        <el-table-column prop="projectTypeDesc" label="项目类型" align="center"></el-table-column>
        <el-table-column prop="signingDate" label="签订日期" min-width="110"></el-table-column>
        <el-table-column prop="paymentDate" label="收费日期" min-width="110"></el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" style="color: #F56C6C;" size="small" @click="delFn(scope.row)">删除</el-button>
            <el-button type="text" v-if="scope.row.flowStatus === 0" size="small" @click="handleView(scope.row, 'edit')">编辑</el-button>
            <el-button type="text" v-if="scope.row.flowStatus !== 0" size="small" @click="handleView(scope.row, 'preview')">查看</el-button>
            <el-button type="text" v-if="scope.row.flowStatus === 0" style="color: #E6A23C;margin-left: 0;" size="small" @click="submitApproval(scope.row)">提交审批</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 16px; text-align: right;"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>

    <!-- 合同编辑弹窗 -->
    <ContractFormDialog
      :visible.sync="dialogVisible"
      :row="currentRow"
      :type="dialogType"
      @success="getDataList"
    />
    </el-card>
  </div>
</template>

<script>
import ContractFormDialog from './ContractFormDialog.vue'

export default {
  components: { ContractFormDialog },
  data () {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        customerName: '',
        contractNo: '',
        contractStatus: '',
        paymentMethod: '',
        paymentType: '',
        projectType: '',
        flowStatus: ''
      },
      paymentDateRange: [],
      tableData: [],
      tableLoading: false,
      total: 0,
      contractStatusList: [],
      paymentMethodList: [],
      paymentTypeList: [],
      projectTypeList: [],
      flowStatusList: [],
      dialogVisible: false,
      dialogType: '',
      currentRow: {}
    }
  },
  created () {
    this.queryForm.flowStatus = this.$route.query.flowStatus ? Number(this.$route.query.flowStatus) : ''
    this.queryForm.projectType = this.$route.query.projectType
    this.getSelectList()
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getSelectList () {
      this.$http.get('contractPaymentInfo/enums').then(res => {
        if (res.code === 200) {
          this.contractStatusList = res.data.contractStatusList || []
          this.paymentMethodList = res.data.paymentMethodList || []
          this.paymentTypeList = res.data.paymentTypeList || []
          this.projectTypeList = res.data.projectTypeList || []
        }
      })
      this.$http.get('flow/applyStatusEnums').then(res => {
        if (res.code === 200) {
          this.flowStatusList = res.data
        }
      })
    },
    getDataList () {
      this.tableLoading = true
      const params = { ...this.queryForm }
      // 剔除空参数
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })
      this.$http.get('contractPaymentInfo/page', { params }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取数据失败')
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
        this.$message.error('获取数据失败')
      })
    },
    handleQuery () {
      this.queryForm.pageNum = 1
      this.getDataList()
    },
    handleReset () {
      this.queryForm = {
        pageNum: 1,
        pageSize: this.queryForm.pageSize,
        customerName: '',
        contractNo: '',
        contractStatus: '',
        paymentMethod: '',
        paymentType: '',
        projectType: ''
      }
      this.paymentDateRange = []
      this.handleQuery()
    },
    exportFn () {
      var downForm = JSON.parse(JSON.stringify(this.queryForm))
      var downLoadUrl = this.$env.baseIP + 'contractPaymentInfo/export'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', downForm)
    },
    handleDateRangeChange (val) {
      if (val && val.length === 2) {
        this.queryForm.paymentDateStart = val[0]
        this.queryForm.paymentDateEnd = val[1]
      } else {
        this.queryForm.paymentDateStart = ''
        this.queryForm.paymentDateEnd = ''
      }
    },
    handleSizeChange (val) {
      this.queryForm.pageSize = val
      this.queryForm.pageNum = 1
      this.getDataList()
    },
    handleCurrentChange (val) {
      this.queryForm.pageNum = val
      this.getDataList()
    },
    getStatusType (status) {
      const map = {
        草稿: '',
        已签订: 'success',
        执行中: 'warning',
        已完成: 'success',
        已终止: 'danger'
      }
      return map[status] || ''
    },
    getFlowStatusStr (status) {
      return this.flowStatusList.find(item => item.code === status).desc
    },
    getFlowStatusType (status) {
      const map = ['warning', '', 'success', 'danger', 'danger']
      return map[status]
    },
    handleView (row, type) {
      this.currentRow = row
      this.dialogVisible = true
      this.dialogType = type
    },
    delFn (row) {
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`contractPaymentInfo/delete/${row.id}`).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功!')
            this.getDataList()
          }
        })
      }).catch(() => {})
    },
    submitApproval (row) {
      if (!row.id) {
        this.$message.warning('缺少合同ID，无法提交审批')
        return
      }
      this.$confirm('确认提交该合同进入审批流程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('contractPaymentInfo/submit/' + row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success('提交审批成功')
            // 提交成功后刷新合同列表
            this.getDataList()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
